import './search-result.scss';

/**
 * version    1.0
 * class      <type> (SearchResult)
 * classdesc   SearchResult
 */
export class SearchResult {}
